import React from 'react';
import { XAxis } from 'react-stockcharts/lib/axes';
import { connect } from 'react-redux';
import { XAxisConfig } from './ChartConfig';
import moment from 'moment';

const CustomXAxis = props => {
  const { theme } = props;
  const strokeColor = XAxisConfig[theme];

  let tickFormat = d => {
    const tradingDate = moment(props.data[d].tradingDate);
    tradingDate.locale(props.locale);
    return tradingDate.format(props.format).toString();
  };

  if (props.tickFormat) {
    tickFormat = props.tickFormat;
  }

  return (
    <XAxis
      axisAt="bottom"
      orient="top"
      tickStroke="#d2d3d4"
      stroke={strokeColor}
      tickPadding={0}
      strokeWidth={30}
      innerTickSize={0}
      outerTickSize={15}
      fontSize={9}
      edgeClip={true}
      tickSize={2}
      tickValues={props.tickValues}
      zoomEnabled={false}
      tickFormat={tickFormat}
    />
  );
};

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(CustomXAxis);
